export const messages = {
  en: {
    aAccessControl: {
      search: {
        title: 'Search Conditions',
        machineCode: 'Please enter device code',
        machineName: 'Please enter device name',
        locationName: 'Please enter location name'
      },
      list: {
        title: 'Access Control Information'
      },
      add: {
        title: 'Add Device',
        editTitle: 'Edit Device'
      },
      form: {
        machineName: 'Device Name',
        machineNamePlaceholder: 'Please enter device name',
        machineCode: 'Device Code',
        machineCodePlaceholder: 'Please enter device code',
        mqttDeviceId: 'MQTT Device SN',
        mqttDeviceIdPlaceholder: 'Enter device SN (e.g. NY260117A0304000851)',
        direction: 'Direction',
        directionPlaceholder: 'Please select direction',
        floor: 'Building',
        floorPlaceholder: 'Please select building',
        unit: 'Unit',
        unitPlaceholder: 'Please select unit (optional)',
        machineIp: 'Device IP',
        machineIpPlaceholder: 'Please enter device IP',
        machineMac: 'Device MAC',
        machineMacPlaceholder: 'Please enter device MAC'
      },
      directionOptions: {
        in: 'In',
        out: 'Out'
      },
      table: {
        communityName: 'Community Name',
        machineCode: 'Device Code',
        machineName: 'Device Name',
        machineIp: 'IP',
        machineMac: 'Mac',
        promptSwitch: 'Prompt Switch',
        direction: 'Direction',
        implBean: 'Manufacturer',
        locationName: 'Location',
        mqttState: 'MQTT Status',
        mqttHeartbeatTime: 'MQTT Heartbeat',
        stateName: 'Online Status',
        heartbeatTime: 'Heartbeat Time'
      },
      mqttState: {
        online: 'Online',
        offline: 'Offline',
        unknown: 'Unknown'
      },
      direction: {
        in: 'In',
        out: 'Out'
      },
      fetchError: 'Failed to get access control list',
      saveSuccess: 'Device saved successfully',
      updateSuccess: 'Device updated successfully'
    }
  },
  zh: {
    aAccessControl: {
      search: {
        title: '查询条件',
        machineCode: '请输入设备编码',
        machineName: '请输入设备名称',
        locationName: '请输入位置名称'
      },
      list: {
        title: '门禁信息'
      },
      add: {
        title: '添加设备',
        editTitle: '编辑设备'
      },
      form: {
        machineName: '设备名称',
        machineNamePlaceholder: '请输入设备名称',
        machineCode: '设备编码',
        machineCodePlaceholder: '请输入设备编码',
        mqttDeviceId: 'MQTT设备SN',
        mqttDeviceIdPlaceholder: '请输入设备SN号（如 NY260117A0304000851）',
        direction: '设备方向',
        directionPlaceholder: '请选择设备方向',
        floor: '安装位置',
        floorPlaceholder: '不选则默认为小区大门',
        unit: '单元',
        unitPlaceholder: '请选择单元（可选）',
        machineIp: '设备IP',
        machineIpPlaceholder: '请输入设备IP',
        machineMac: '设备MAC',
        machineMacPlaceholder: '请输入设备MAC'
      },
      directionOptions: {
        in: '进',
        out: '出'
      },
      table: {
        communityName: '小区名称',
        machineCode: '门禁编码',
        machineName: '门禁名称',
        machineIp: 'IP',
        machineMac: 'Mac',
        promptSwitch: '开门提示',
        direction: '方向',
        implBean: '厂家',
        locationName: '位置',
        mqttState: 'MQTT状态',
        mqttHeartbeatTime: 'MQTT心跳时间',
        stateName: '在线',
        heartbeatTime: '心跳时间'
      },
      mqttState: {
        online: '在线',
        offline: '离线',
        unknown: '未知'
      },
      direction: {
        in: '进',
        out: '出'
      },
      fetchError: '获取门禁列表失败',
      saveSuccess: '设备添加成功',
      updateSuccess: '设备更新成功'
    }
  }
}
